import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import { toast } from "react-toastify";
import fmApi from "../APIWrapper";

function* resetPassword(params) {
  let data = params?.value?.data;
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/identityservice/user/updatePassword`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   let errJSON = {};
    //   try {
    //     errJSON = yield res.json();
    //   } catch {}
    //   throw Object.assign(res, errJSON);
    // } else {
    const resJSON = yield call(fmApi.PostRecoverPassApi, data);

    yield put({
      type: actionTypes.RESET_PASSWORD_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Password has been reset successfully", {
      autoClose: 3000,
    });
    yield put(push("/login"));
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.RESET_PASSWORD_FAIL_ACTION,
        error: err,
        payload: "",
      });
      yield toast.error(
        "Failed to reset the password. Please try again later",
        {
          autoClose: 3000,
        }
      );
    } else {
    }
  }
}

export function* resetPasswordActionWatcher() {
  yield takeEvery(actionTypes.RESET_PASSWORD_INIT_ACTION, resetPassword);
}
